import { Link } from 'react-router-dom';
import Eyebrow from '@/components/base/Eyebrow';

const values = [
  { title: 'Clarity', copy: 'Plain, honest advice that helps people make decisions with confidence.' },
  { title: 'Curiosity', copy: 'Asking better questions to understand what is really going on.' },
  { title: 'Integrity', copy: 'Doing what we say, and saying what needs to be said.' },
  { title: 'Human Connection', copy: 'Relationships built on respect, warmth and genuine interest.' },
];

export default function ValuesCta() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="wrap">
        <div className="mx-auto max-w-[1280px]">
          <Eyebrow>OUR VALUES</Eyebrow>
          <h2 className="mt-6 max-w-[760px] font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] tracking-[-0.015em] text-foreground-950">
            Better work begins with better relationships.
          </h2>
          <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-foreground-950/15">
            {values.map((v, i) => (
              <div key={v.title} className={`py-7 sm:pr-6 lg:px-6 border-b lg:border-b-0 border-foreground-950/15 ${i > 0 ? 'lg:border-l' : 'lg:pl-0'}`}>
                <h3 className="font-heading text-[24px] text-foreground-950">{v.title}</h3>
                <p className="mt-3 text-[15px] leading-[1.6] text-foreground-700">{v.copy}</p>
              </div>
            ))}
          </div>
          <div className="mt-16 md:mt-20 pt-8 border-t border-foreground-950/15 flex flex-col md:flex-row md:items-end justify-between gap-6">
            <p className="font-display font-normal text-[26px] md:text-[32px] leading-[1.15] text-foreground-950 max-w-xl">
              Ready to talk about your people and plans?
            </p>
            <Link
              to="/contact"
              className="self-start md:self-auto inline-flex items-center gap-1 text-[15px] font-medium text-foreground-950 border-b border-foreground-950 pb-0.5 whitespace-nowrap hover:text-accent-600 hover:border-accent-500 transition-colors cursor-pointer"
            >
              Get in touch <i className="ri-arrow-right-up-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}